<template>
 <main class="d-flex align-items-center min-vh-100 py-3 py-md-0">
      <div class="container">
        <div class="card login-card">
  <v-app>
    <v-card>
      <v-row>
        <v-col cols="12" md="12">
          <v-spacer></v-spacer>

           <div class="brand-wrapper" v-if="showLogoBusiness">
            <a href=""> <img :src="Logobusiness" alt="logo" class="logo"/></a>
          </div>
          <v-container style="margin-top:20px">
            <v-row>
              <v-col
                v-for="(category, keycategory) in categories"
                :key="keycategory"
                cols="4"
                md="4"
                sm="12"
              >
                <v-card class="mx-auto">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title class="text-h5">
                        {{ category._id }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        >{{ humazinedate() }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-card-text>
                    <v-row align="center">
                      <v-col class="text-h2" cols="6">
                        {{ category.quantite }}
                      </v-col>
                      <v-col cols="6">
                        <v-img
                          :src="category.imagecode"
                          alt="Sunny image"
                          width="92"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>


              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <v-menu
            v-model="showPicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            max-width="300px"
            min-width="300px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="selectedDate"
                label="Date"
                prepend-icon="mdi-calendar"
                hint="YYYY/MM/DD"
                persistent-hint
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedDate"
              locale="fr"
              no-title
              :allowed-dates="disablePastDates"
              scrollable
              @input="showPicker = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-card-title>
        <v-text-field
          v-model="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-simple-table fixed-header>
        <template v-slot:default>
          <thead>
            <tr>
              <th
                class="text-left"
                v-for="(header, keyheader) in headers"
                :key="keyheader"
              >
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(order, keyorder) in listOrders" :key="keyorder">
              <td>{{ order.name }}</td>
              <td>
                <a :href="'tel:' + order.tel">{{ order.tel }}</a>
              </td>
              <td>
                <v-chip-group>
                  <v-chip
                    v-for="(product, keyproduct) in order.products"
                    :key="keyproduct"
                    class="ma-2 label-cat"
                    label
                  >
                    {{ product.product }} &nbsp;

                    <strong
                      :style="{
                        width: '20px',
                        height: '20px',
                        'background-color': '#00a65ad4',
                        'text-align': 'center',
                        color: '#fafafa',
                        'border-radius': '100%'
                      }"
                    >
                      {{ product.quantity }}
                    </strong>
                  </v-chip>
                </v-chip-group>
              </td>
              <td>
                {{ order.indication }} <br />
                <a
                  :href="
                    'http://www.google.com/maps/place/' +
                      order.gps.lat +
                      ',' +
                      order.gps.lng
                  "
                  >Tracer GPS</a
                >
              </td>
              <td>
                {{ order.dateorder }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-app>
    </div>
      </div>
    </main>
</template>

<script>
import Papa from 'papaparse';

import beignets from '../assets/images/codes/beignets.png';
import cookies from '../assets/images/codes/dookies.png';
import crepe from '../assets/images/codes/crepes.png';
import box from '../assets/images/codes/box.png';
import pancakes from '../assets/images/codes/pancakes.png';
import cakes from '../assets/images/codes/cakes.png';
import soukeroukor from '../assets/images/codes/Soukëru Koor.png';

var moment = require("moment");
moment.locale("fr");
export default {
  title: "DashboardHome",
  components: {},
  data() {
    return {
      labels: ["SU", "MO", "TU", "WED", "TH", "FR", "SA"],
      Logobusiness: null,
      titleshop: null,
      subdomain: null,
      time: 0,
      forecast: [
        {
          day: "Tuesday",
          icon: "mdi-white-balance-sunny",
          temp: "24\xB0/12\xB0"
        },
        {
          day: "Wednesday",
          icon: "mdi-white-balance-sunny",
          temp: "22\xB0/14\xB0"
        },
        { day: "Thursday", icon: "mdi-cloud", temp: "25\xB0/15\xB0" }
      ],

      search: "",
      idshop: "",
      showPicker: false,
      categories: [],
      selectedDate: new Date().toISOString().substr(0, 10),
      showPicker: false,
      j_plus: 3,
      redirect: "https://kiosk.ojay.delivery/ojaybackend",
      headers: [
        {
          text: "Prénom nom",
          align: "left",
          filterable: false,
          value: "name"
        },
        { text: "téléphone", value: "tel" },
        { text: "produit", value: "products" },
        { text: "Indication et localisation", value: "indication" },
        { text: "date de commande", value: "products" }
      ],
      listOrders: [],
      desserts: [],
      showLogoBusiness: false
    };
  },

  watch: {
    selectedDate(newval, oldval) {
      console.log("_________selectedDate__________");
      console.log("changement de date selectedDate newval", newval);
      console.log("new val selectedDate oldval", oldval);
      console.log("__________________________________");

      var beginday = moment(new Date(newval)).format(
        "YYYY-MM-DD[T00:00:00.000Z]"
      );
      var endday = moment(new Date(newval)).format(
        "YYYY-MM-DD[T23:59:59.000Z]"
      );
      var paramsdate = { gte: beginday, lte: endday };
      console.log("paramsdate watch selectedDate ==>", paramsdate);

      this.findOrderperdate(paramsdate);
      this.getCategories(paramsdate);
    }
  },
  computed: {
    past_date: function() {
      var date = new Date();
      console.log("dat.getDate ==>", date.getDate());
      console.log("j_plus", this.j_plus);
      date.setDate(date.getDate() + this.j_plus);
      return date.toISOString().substr(0, 10);
    }
  },
  mounted() {
    console.log("on monte zer", this.$route.params.idshop);
    this.idshop = this.$route.params.idshop;
    this.getInfoShop(this.$route.params.idshop)
    this.getTodayOrders(this.$route.params.idshop);
    var beginmount = moment(new Date()).format("YYYY-MM-DD[T00:00:00.000Z]");
    var endinmount = moment(new Date()).format("YYYY-MM-DD[T23:59:59.000Z]");
    var paramsbegin = { gte: beginmount, lte: endinmount };
    console.log("paramsbegin ===>", paramsbegin);
    console.log("<---------------------------->");
    this.getCategories(paramsbegin);
  },
  methods: {
    downloadCSV(dataOrders) {
      console.log('downloadCSV =>',dataOrders);
      const csv = Papa.unparse(dataOrders);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', 'orders.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    humazinedate() {
      return moment(this.selectedDate).format("dddd, MMMM Do YYYY");
    },
    getInfoShop(idshopzer){
      console.log('getInfoShop::::::>',idshopzer)
      let Oldthis = this
      this.$http.get(this.redirect + "/get/infos/shop/" + idshopzer).then(
        function(response) {
          console.log("from get SHOP==>", response.data.shop);
          if (response.data.shop) {
              console.log('condition veriféé')
              Oldthis.showLogoBusiness = true;
              Oldthis.Logobusiness  = Oldthis.redirect + '/public/'+response.data.shop.Logobusiness
              Oldthis.titleshop = response.data.shop.titleshop
              Oldthis.subdomain = response.data.shop.subdomain
          }
        },
        function(response) {
          console.log(response, "error");
        }
      );

    },
    treatementCategoriesObject(categories){

        return  categories.map((category) => {
          var imagebi =null;
          if(category._id == 'Box'){
              imagebi = box
          }
          if(category._id == 'Beignets'){
              imagebi = beignets
          }
           if(category._id == 'Cakes'){
              imagebi = cakes
          }
          if(category._id == 'Crêpes'){
              imagebi = crepe
          }
          if(category._id == 'Cookies'){
              imagebi = cookies
          }

           if(category._id == 'Pancakes'){
              imagebi = pancakes
          }

          if(category._id == "Soukëru Koor"){
               imagebi =  soukeroukor
          }


          return Object.assign(category,{imagecode:imagebi})
        });
        listorderformatted.push(
          Object.assign(newOrder, { products: cartOrder })
        );
    },
    getCategories(paramsdate) {
      const Oldthis = this;

      console.log("getCategoriessss===>");
      console.log('<--------------ID SHOP------------->',this.idshop);

      console.log("selectedDate===>", this.selectedDate);
      //let redirection = "https://douxgup.ojay.delivery/test";
      this.$http
        .post(this.redirect + "/get/categories/" + this.idshop, {
          datelte: paramsdate
        })
        .then(
          function(response) {
            console.log("from get Categories==>", response.data);
            if (response.data.categories) {
              Oldthis.categories =  Oldthis.treatementCategoriesObject(response.data.categories);

            }
          },
          function(error) {
            console.log("error get Categories==>", error);

            console.log(response, "error");
          }
        );
    },
    stringifyOrder(orders) {
      return orders.map(order => {
        // Convert products array to string
        const productsString = order.products.map(product =>
          `${product.product} ${product.quantity} unités prixtotal ${product.totalprice}`
        ).join(', ');

        // Replace the products array with the products string
        return { ...order, products: productsString };
      });
    },
    findOrderperdate(date) {
      const Oldthis = this;
      console.log("===> findOrderperdate <===", date);
      //let redirection = "https://douxgup.ojay.delivery/test";
      this.$http
        .post(this.redirect + "/get/orders/" + this.idshop, { datelte: date })
        .then(
          function(response) {
            console.log("response findOrderperUpdate", response);
            if (response.data.orders) {
              Oldthis.listOrders = this.treatementOfDatatoShow(
                response.data.orders
              );

              if(Oldthis.listOrders.length)
              {
                Oldthis.downloadCSV(Oldthis.stringifyOrder(Oldthis.listOrders));
              }

            }
          },

          function(response) {
            console.log(response, "error  findOrderperUpdate");
          }
        );
    },
    disablePastDates(val) {
      // return val >= this.past_date
      return val <= new Date().toISOString().substr(0, 10);
    },

    treatementOfDatatoShow(orders) {
      var listorderformatted = [];
      orders.forEach(orderlist => {
        let { created_at } = orderlist;
        let {
          order: {
            coordinates: { firstname }
          }
        } = orderlist;

        let {
          order: {
            coordinates: { lastname }
          }
        } = orderlist;
        let {
          order: {
            coordinates: { tel }
          }
        } = orderlist;
        let {
          order: {
            delivery: { adress_indication }
          }
        } = orderlist;
        let {
          order: {
            delivery: {
              locationdetails: { location }
            }
          }
        } = orderlist;
        const name = firstname + " " + lastname;
        var newOrder = {
          name: name,
          tel: tel,
          indication: adress_indication,
          gps: location,
          dateorder: created_at
        };

        var cartOrder = orderlist.order.cart.map(cartline => {
          return {
            product: cartline.article.title,
            quantity: cartline.quantity,
            totalprice: cartline.total_price
          };
        });
        listorderformatted.push(
          Object.assign(newOrder, { products: cartOrder })
        );
      });
      return listorderformatted;
    },

    getTodayOrders(idshop) {
      this.idshop = idshop;
      var beginday = moment(new Date()).format("YYYY-MM-DD[T00:00:00.000Z]");
      var endday = moment(new Date()).format("YYYY-MM-DD[T23:59:59.000Z]");
      var paramsdate = { gte: beginday, lte: endday };
      console.log("paramsdate", paramsdate);

      this.findOrderperdate(paramsdate);
      /*
      console.log("the redirect path", this.redirect);
      const Oldthis = this;
      this.$http.get(this.redirect + "/get/orders/" + idshop).then(
        function(response) {
          console.log("from get==>", response.data);
          if (response.data.orders) {
            Oldthis.listOrders = this.treatementOfDatatoShow(
              response.data.orders
            );
          }
        },
        function(response) {
          console.log(response, "error");
        }
      );*/
    }
  }
};
</script>

<style>
.label-cat {
  border-radius: 20px !important;
}

.cardbi {
  border-radius: 6px;
  box-shadow: 0 2px 2px rgb(204 197 185 / 50%);
  background-color: #fff;
  color: #252422;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  border: none;
}

.cardbi .card-body {
  padding: 15px 15px 10px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardHome.vue